import React from 'react'
import styled from 'styled-components'

export default function Wrapper({ children, dataTestId }) {
  return <StyledWrapper data-testid={dataTestId}>{children}</StyledWrapper>
}

const StyledWrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;
  min-height: 100vh;

  @media (max-width: 670px) {
    width: 100%;
    padding: 15px;
    min-height: fit-content;
  }
`
